import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';

class Footer extends React.Component {
  render() {
    return (
      <>
        <div><Link to="/privacy">Privacy Page</Link></div>
        <div><Link to="/delete-account">Delete Account</Link></div>
        <div><Link to="/delete-data">Delete Data</Link></div>
      </>
    );
  }
}

export default Footer;